import * as yup from "yup";
import {
  DriveType,
  HydraulicCouplerType,
  PtoSpeed,
  PtoType,
} from "protos/atk/enums";

export const hydraulicCouplerTypeSchema = yup
  .number()
  .oneOf(
    [
      HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_12_5,
      HydraulicCouplerType.HYD_COUPLER_ISO_5675_SIZE_20,
    ],
    "utils.form.required"
  )
  .required("utils.form.required");

export const positiveNumberSchema = yup
  .number()
  .typeError("utils.form.numberType")
  .moreThan(0, "utils.form.mustBeGreaterThan");

const scvOutputSchema = yup.object({
  port: yup
    .number()
    .typeError("utils.form.numberType")
    .required("utils.form.required"),
  description: yup.string().optional(),
  coupler: hydraulicCouplerTypeSchema,
  disabled: yup.boolean().required("utils.form.required"),
});

export const scvOutputsSchema = yup.object({
  scvOutput: yup.array().of(scvOutputSchema),
});

export const ptoConfigSchema = yup.object({
  disabled: yup.boolean(),
  availableSpeeds: yup
    .array()
    .of(
      yup
        .number()
        .typeError("utils.form.numberType")
        .required("utils.form.required")
    ),
});

export const hitchConfigSchema = yup.object({
  hitches: yup.array().of(
    yup.object({
      type: yup
        .number()
        .min(1, "utils.form.selectionRequired")
        .typeError("utils.form.numberType")
        .required("utils.form.required"),
      offsetYM: yup
        .number()
        .typeError("utils.form.numberType")
        .required("utils.form.required"),
    })
  ),
});

export const steeringRangeSchema = yup.object({
  min: yup
    .number()
    .typeError("utils.form.numberType")
    .required("utils.form.required")
    .test("less-than-max", "utils.form.minGreaterThanMax", function (v) {
      return v <= this.parent.max;
    }),
  max: yup
    .number()
    .typeError("utils.form.numberType")
    .required("utils.form.required")
    .test("greater-than-min", "utils.form.maxLessThanMin", function (v) {
      return v >= this.parent.min;
    }),
});

export const driveTypeSchema = yup
  .number()
  .oneOf(
    [
      DriveType.DRIVE_TYPE_FRONT_AXLE_STEER,
      DriveType.DRIVE_TYPE_DIFFERENTIAL_STEER,
    ],
    "utils.form.required"
  );
const point2DSchema = yup.object({
  x: yup
    .number()
    .typeError("utils.form.numberType")
    .required("utils.form.required"),
  y: yup
    .number()
    .typeError("utils.form.numberType")
    .required("utils.form.required"),
});

export const polygon2DSchema = yup.object({
  points: yup.array().of(point2DSchema),
});

export const ptoRequirementsSchema = yup.object({
  type: yup
    .number()
    .oneOf(
      [
        PtoType.PTO_TYPE_NONE,
        PtoType.PTO_TYPE_FRONT,
        PtoType.PTO_TYPE_FRONT_AND_REAR,
        PtoType.PTO_TYPE_REAR,
      ],
      "utils.form.required"
    )
    .required("utils.form.required"),
  engineSpeedRpm: yup.number().when("type", {
    is: PtoType.PTO_TYPE_NONE,
    // eslint-disable-next-line unicorn/no-thenable
    then: (schema) => schema.strip(),
    otherwise: (schema) =>
      schema
        .min(0, "utils.utils.form.greaterOrEqualZero")
        .required("utils.form.required"),
  }),
  ptoSpeed: yup.number().when("type", {
    is: PtoType.PTO_TYPE_NONE,
    // eslint-disable-next-line unicorn/no-thenable
    then: (schema) => schema.strip(),
    otherwise: (schema) =>
      schema
        .oneOf(
          [
            PtoSpeed.PTO_SPEED_540E,
            PtoSpeed.PTO_SPEED_540,
            PtoSpeed.PTO_SPEED_1000E,
            PtoSpeed.PTO_SPEED_1000,
          ],
          "utils.form.required"
        )
        .required("utils.form.required"),
  }),
});

export const scvInputsSchema = yup.object({
  inputs: yup.array().of(
    yup
      .object({
        id: yup.string().notRequired(),
        function: yup.string().required("utils.form.required"),
        recommendedPort: yup.string().required("utils.form.required"),
        coupler: hydraulicCouplerTypeSchema,
      })
      .required("utils.form.required")
  ),
});
